import { Button, Switch, TableCell, TableRow, useTheme } from '@mui/material'

import { useMe } from 'src/hooks'

import { getTableTimestamp } from 'src/common/utils'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { IRedirectURLRespDto } from 'src/types/redirect-url.type'
import { RedirectURLModal } from '../modal'
import React from 'react'
import { LinkIcon } from 'src/assets/icons'
import useStyles from './styles'
import { ConfirmDeleteModal } from '../modal/confirm-delete.modal'
import { useRedirectURLChangeActive } from 'src/hooks/redirect-urls/use-change-redirect-url-active.hook'

interface IImpactCategoryRowProps {
  row: IRedirectURLRespDto
}

export const ItemRow = ({ row }: IImpactCategoryRowProps) => {
  const { data: user } = useMe()
  const theme = useTheme()
  const [modalOpen, setModalOpen] = React.useState<boolean>(false)
  const [delModalOpen, setDelModalOpen] = React.useState<boolean>(false)
  const style = useStyles()
  const { mutate } = useRedirectURLChangeActive()
  const handleRedirect = (url: string) => {
    window.open(url, '_blank')
  }

  return (
    <>
      <TableRow
        style={{
          backgroundColor: theme.palette.custom.white,
          tableLayout: 'fixed',
        }}
      >
        <TableCell align="center">{row.note || '-'}</TableCell>
        <TableCell align="center">
          <div className={style.cell}>
            {row.redirect_url}
            <Button
              size="small"
              className={style.btn}
              onClick={() => handleRedirect(row.redirect_url)}
            >
              <LinkIcon />
            </Button>
          </div>
        </TableCell>
        <TableCell align="center">
          <div className={style.cell}>
            {row.redirect_target}
            <Button
              size="small"
              className={style.btn}
              onClick={() => handleRedirect(row.redirect_target)}
            >
              <LinkIcon />
            </Button>
          </div>
        </TableCell>
        <TableCell align="center">
          {' '}
          {getTableTimestamp({ date: row.updated_at, timezone: user?.timezone })}
        </TableCell>
        <TableCell align="center">
          <Switch onClick={() => mutate(row.id)} checked={row.active} />
        </TableCell>
        <TableCell align="center">
          <Button
            onClick={() => {
              setModalOpen(true)
            }}
          >
            <HelperWrapper t={'update-button-text'} />
          </Button>
        </TableCell>
        <TableCell align="center">
          <Button
            onClick={() => {
              setDelModalOpen(true)
            }}
            color="error"
          >
            <HelperWrapper t={'delete-button-text'} />
          </Button>
        </TableCell>
      </TableRow>
      <RedirectURLModal
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        redirectURL={row.redirect_url}
        redirectTarget={row.redirect_target}
        note={row.note}
        id={row.id}
      />
      <ConfirmDeleteModal modalOpen={delModalOpen} setModalOpen={setDelModalOpen} id={row.id} />
    </>
  )
}
